

window.blockScreen = function() {
    $.blockUI({
        message: '<img src="js/loading.gif" /><br/>Подождите, выполняется операция в NCALayer...',
        css: {
            border: 'none',
            padding: '15px',
            backgroundColor: '#000',
            '-webkit-border-radius': '10px',
            '-moz-border-radius': '10px',
            opacity: .5,
            color: '#fff'
        }
    });
}

window.openDialog = function() {
    if (confirm("Ошибка при подключении к NCALayer. Запустите NCALayer и нажмите ОК") === true) {
        location.reload();
    }
}

window.unblockScreen = function() {
    $.unblockUI();
}



window.getActiveTokens = function(callBack) {
    var getActiveTokens = {
		"module": "kz.gov.pki.knca.commonUtils",
        "method": "getActiveTokens"
    };
    callback = callBack;
    window.webSocket.send(JSON.stringify(getActiveTokens));
}

window.getKeyInfo = function(storageName, callBack) {
    var getKeyInfo = {
		"module": "kz.gov.pki.knca.commonUtils",
        "method": "getKeyInfo",
        "args": [storageName]
    };
    callback = callBack;
    window.webSocket.send(JSON.stringify(getKeyInfo));
}

window.signXml = function(storageName, keyType, xmlToSign, callBack) {
    var signXml = {
		"module": "kz.gov.pki.knca.commonUtils",
        "method": "signXml",
        "args": [storageName, keyType, xmlToSign, "", ""]
    };
    callback = callBack;
    window.webSocket.send(JSON.stringify(signXml));
}
function signXmlBack(r){
    console.log(r)
}
window.signXml = function(storageName, keyType, xmlToSign, callBack) {
    var signXml = {
		"module": "kz.gov.pki.knca.commonUtils",
        "method": "signXml",
        "args": [storageName, keyType, xmlToSign, "", ""]
    };
    callback = callBack;
    window.webSocket.send(JSON.stringify(signXml));
}

window.createCAdESFromFile = function(storageName, keyType, filePath, flag, callBack) {
    var createCAdESFromFile = {
		"module": "kz.gov.pki.knca.commonUtils",
        "method": "createCAdESFromFile",
        "args": [storageName, keyType, filePath, flag]
    };
    callback = callBack;
    window.webSocket.send(JSON.stringify(createCAdESFromFile));
}

window.createCAdESFromBase64 = function(storageName, keyType, base64ToSign, flag, callBack) {
    var createCAdESFromBase64 = {
		"module": "kz.gov.pki.knca.commonUtils",
        "method": "createCAdESFromBase64",
        "args": [storageName, keyType, base64ToSign, flag]
    };
    callback = callBack;
    window.webSocket.send(JSON.stringify(createCAdESFromBase64));
}

window.createCAdESFromBase64Hash = function(storageName, keyType, base64ToSign, callBack) {
    var createCAdESFromBase64Hash = {
		"module": "kz.gov.pki.knca.commonUtils",
        "method": "createCAdESFromBase64Hash",
        "args": [storageName, keyType, base64ToSign]
    };
    callback = callBack;
    window.webSocket.send(JSON.stringify(createCAdESFromBase64Hash));
}

window.applyCAdEST = function(storageName, keyType, cmsForTS, callBack) {
    var applyCAdEST = {
		"module": "kz.gov.pki.knca.commonUtils",
        "method": "applyCAdEST",
        "args": [storageName, keyType, cmsForTS]
    };
    callback = callBack;
    window.webSocket.send(JSON.stringify(applyCAdEST));
}

window.showFileChooser = function(fileExtension, currentDirectory, callBack) {
    var showFileChooser = {
		"module": "kz.gov.pki.knca.commonUtils",
        "method": "showFileChooser",
        "args": [fileExtension, currentDirectory]
    };
    callback = callBack;
    window.webSocket.send(JSON.stringify(showFileChooser));
}

window.changeLocale = function(language) {
    var changeLocale = {
		"module": "kz.gov.pki.knca.commonUtils",
        "method": "changeLocale",
        "args": [language]
    };
    callback = null;
    window.webSocket.send(JSON.stringify(changeLocale));
}

window.createCMSSignatureFromFile = function(storageName, keyType, filePath, flag, callBack) {
    var createCMSSignatureFromFile = {
		"module": "kz.gov.pki.knca.commonUtils",
        "method": "createCMSSignatureFromFile",
        "args": [storageName, keyType, filePath, flag]
    };
    callback = callBack;
    window.webSocket.send(JSON.stringify(createCMSSignatureFromFile));
}

window.createCMSSignatureFromBase64 = function(storageName, keyType, base64ToSign, flag, callBack) {
    var createCMSSignatureFromBase64 = {
		"module": "kz.gov.pki.knca.commonUtils",
        "method": "createCMSSignatureFromBase64",
        "args": [storageName, keyType, base64ToSign, flag]
    };
    callback = callBack;
    window.webSocket.send(JSON.stringify(createCMSSignatureFromBase64));
}